export const youtubeParser = url => {
	const regExp = /^.*(youtu.be\/|youtube(-nocookie)?.com\/(v\/|.*u\/\w\/|embed\/|.*v=))([\w-]{11}).*/
	const test = 'https://www.youtube.com/watch?v=PB-fsmc-TLo'
	const match = test.match(regExp)
	if (match && match[match.length - 1].length === 11) {
	  return match[match.length - 1]
	}
}
